module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/management/job-market/talent-capacity-breakdown/talent-capacity-breakdown.component.css
// module id = ./src/app/web/game/management/job-market/talent-capacity-breakdown/talent-capacity-breakdown.component.css
// module chunks = main